import script from "./ImportacaoSigaaView.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportacaoSigaaView.vue?vue&type=script&setup=true&lang=js"

import "./ImportacaoSigaaView.vue?vue&type=style&index=0&id=36e42df0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e42df0"]])

export default __exports__